import React, { Component } from 'react';
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';
import FormJobPageButtons from "../../components/portfolio/FormJobPage/FormJobPageButtons";
import FormJobPagePredilectionInput from "../../components/portfolio/FormJobPage/FormJobPagePredilectionInput";
import { FormattedMessage, injectIntl } from "react-intl";
import ContentLoader from "../../components/ContentLoader";
import { toast } from "react-toastify";
import MetaTags from '../../components/SEO/MetaTags'
import { handlePublicRequestError, handleRequestError, Request } from '../../helpers/request'
import LocalisationSelect from '../../components/form/LocalisationSelect'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'


class FormJobPage extends Component
{
    state = {
        data: null,
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        exp: '',
        tech: '',
        city: '',
        file: null,
        linkedin: '',
        conditions_accepted: false,
        loading: false,
    };

    componentDidMount() {
        Request.get('job_orders/slug/' + this.props.match.params.slug)
            .then((data) => this.setState({ data: data.offer }))
            .catch(handlePublicRequestError);
    }

    submit(e) {
        e.preventDefault();

        const { intl } = this.props;

        const {
            firstname,
            lastname,
            phone,
            email,
            exp,
            tech,
            city,
            data,
            file,
            linkedin
        } = this.state;

        if (!file) {
            return toast.error(
                intl.formatMessage({
                    id: "portfolio.form_job.toast.file_missing",
                    defaultMessage: "Veuillez importer votre CV."
                })
            )
        }

        this.setState({ loading: true });

        let body = {
            firstname,
            lastname,
            phone,
            email,
            exp,
            tech,
            city,
            linkedin,
            region: null,
        };

        if (file)
            body.file = file;

        Request.post('application/submit/' + data.id, body)
            .then((candidate) => {
                toast.success(
                    intl.formatMessage({
                        id: "portfolio.form_contact.message_sent",
                        defaultMessage: "Votre message a bien été envoyé."
                    })
                );

                this.props.history.push({
                    pathname: addLocalePrefix('/candidature-suite'),
                    candidate_id: candidate.id
                });
            })
            .catch((e) => {
                handleRequestError(e);
                this.setState({ loading: false });
            });
    }

    toggleConditionsAccepted() {
        this.setState({ conditions_accepted: !this.state.conditions_accepted });
    }

    render() {
        return (
            <div className="form-job-page">
                <section className="dev-form">
                    {this.renderForm()}
                </section>
            </div>
        )
    }

    renderForm() {
        const { intl } = this.props;
        const { data } = this.state;

        if (!data)
            return <ContentLoader/>;

        const metaDatas = {
            title: data.title,
            seo_title: data?.seo_title,
            seo_description: data?.seo_description,
            content: data.description,
            hat: data.hat
        }

        return (
            <Container>
                <MetaTags page="apply" data={metaDatas} />
                <div className="form-head">
                    <h1 className="line-heading">
                        {data.title}
                    </h1>
                    <p>
                        <FormattedMessage
                            id="portfolio.form_job.subtitle"
                            defaultMessage="On trouve pour vous !"
                        />
                    </p>
                </div>
                <div className="dev-form-wrap">
                    <Form onSubmit={(e) => this.submit(e)}>
                        <div className="fields-row">
                            <FormGroup>
                                <Label>
                                    <FormattedMessage
                                        id="portfolio.form_job.firstname.label"
                                        defaultMessage="Prénom*"
                                    />
                                </Label>
                                <Input
                                    required
                                    type="text"
                                    className="input-field"
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.form_job.firstname.placeholder",
                                            defaultMessage: "Pierre"
                                        })
                                    }
                                    value={this.state.firstname}
                                    onChange={(e) => this.setState({ firstname: e.target.value })}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    <FormattedMessage
                                        id="portfolio.form_job.lastname.label"
                                        defaultMessage="Nom*"
                                    />
                                </Label>
                                <Input
                                    required
                                    type="text"
                                    className="input-field"
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.form_job.lastname.placeholder",
                                            defaultMessage: "Durand"
                                        })
                                    }
                                    value={this.state.lastname}
                                    onChange={(e) => this.setState({ lastname: e.target.value })}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    <FormattedMessage
                                        id="portfolio.form_job.phone.label"
                                        defaultMessage="Téléphone*"
                                    />
                                </Label>
                                <Input
                                    required
                                    type="text"
                                    className="input-field"
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.form_job.phone.placeholder",
                                            defaultMessage: "Pour vous appeler"
                                        })
                                    }
                                    value={this.state.phone}
                                    onChange={(e) => this.setState({ phone: e.target.value })}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    <FormattedMessage
                                        id="portfolio.form_job.email.label"
                                        defaultMessage="Email*"
                                    />
                                </Label>
                                <Input
                                    required
                                    type="email"
                                    className="input-field"
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.form_job.email.placeholder",
                                            defaultMessage: "Pour vous écrire"
                                        })
                                    }
                                    value={this.state.email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                />
                            </FormGroup>
                        </div>
                        <div className="fields-row">
                            <FormGroup>
                                <Label>
                                    <FormattedMessage
                                        id="portfolio.form_job.linkedin.label"
                                        defaultMessage="Profil LinkedIn*"
                                    />
                                </Label>
                                <Input
                                    required
                                    type="url"
                                    className="input-field"
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.form_job.linkedin.placeholder",
                                            defaultMessage: "https://www.linkedin.com/in/votre-profil"
                                        })
                                    }
                                    pattern="https://.*"
                                    value={this.state.linkedin}
                                    onChange={(e) => this.setState({ linkedin: e.target.value })}
                                />
                            </FormGroup>
                        </div>
                        <div className="select-fields-row">
                            <FormGroup>
                                <Label>
                                    <FormattedMessage
                                        id="portfolio.form_job.years_exp.label"
                                        defaultMessage="Années d'expérience*"
                                    />
                                </Label>
                                <Input
                                    required
                                    type="number"
                                    className="input-field"
                                    min={0}
                                    placeholder={"2"}
                                    value={this.state.exp}
                                    onChange={(e) => this.setState({ exp: e.target.value })}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    <FormattedMessage
                                        id="forms.labels.city_required"
                                        defaultMessage="Ville*"
                                    />
                                </Label>
                                <LocalisationSelect
                                    value={this.state.city}
                                    onChange={city => this.setState({city})}
                                />
                            </FormGroup>
                            <FormGroup className={'predilection-group'}>
                                <FormJobPagePredilectionInput
                                    business_unit={data ? data.business_unit : 'tech'}
                                    required={true}
                                    value={this.state.tech}
                                    onChange={(e) => this.setState({ tech: e.target.value })}
                                />
                            </FormGroup>
                        </div>

                        <FormJobPageButtons
                            onDrop={(file) => this.setState({ file })}
                            onDataLoaded={(data) => this.setState({ ...data })}
                            loading={(loading) => this.setState({ loading })}
                        />

                        <div className="btn-wrap checkbox-wrap">
                            <div className="custom-control checkbox-wrap mb-5">
                                <Input
                                    required
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="posibility"
                                    onChange={() => this.toggleConditionsAccepted()}
                                />
                                <Label className="custom-control-label" htmlFor="posibility">
                                    <span className="box-block mr-3"/>
                                    <span className="check-text">
                                        <FormattedMessage
                                            id="portfolio.form.cgu"
                                            defaultMessage="En cochant la case, vous confirmez avoir lu et accepté les conditions d'utilisation de vos données listées {link}."
                                            values={{
                                                link: (
                                                    <LocaleLink to={'/cgu'} className={'link-cgu'} target='_blank'>
                                                        <FormattedMessage
                                                            id="myurban.header.notifications.new_application_to_job_order.here"
                                                            defaultMessage={'ici'}
                                                        />
                                                    </LocaleLink>
                                                )
                                            }}
                                        />
                                    </span>
                                </Label>
                            </div>
                            <Button
                                className="btn btn-danger"
                                disabled={this.state.loading}
                            >
                                <FormattedMessage
                                    id="portfolio.form_job.button"
                                    defaultMessage="ENVOYER"
                                />
                            </Button>
                        </div>
                    </Form>
                </div>
            </Container>
        )
    }
}

export default injectIntl(FormJobPage);
